import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'aumico-integration-card-coming-soon',
    templateUrl: 'integration-card-coming-soon.component.html',
    styleUrls: ['integration-card-coming-soon.component.scss'],
})
export class IntegrationCardComingSoonComponent {
    @Input() name = '';
    @Input() description = '';
    @Input() logoSrc: string | null = null;
    @Input() bannerBgColor = '#f3f4f6';
    @Input() isPlaceholder = false;

    @Output() requestClicked = new EventEmitter<void>();
}
